import { Fragment } from "react";
import "./Features.css";
import CurrencyBitcoinIcon from "@mui/icons-material/CurrencyBitcoin";
import DeveloperModeIcon from "@mui/icons-material/DeveloperMode";
import AppShortcutIcon from "@mui/icons-material/AppShortcut";
import PaymentIcon from "@mui/icons-material/Payment";
import CurrencyExchangeIcon from "@mui/icons-material/CurrencyExchange";
import blockchain from "../../assets/images/features/blockchain.png";
import fullstack from "../../assets/images/features/fullstack.png";
import app from "../../assets/images/features/app.png";
import payment from "../../assets/images/features/payment.png";
import exchange from "../../assets/images/features/exchange.png";

const Features = () => {
  return (
    <Fragment>
      <section className="features-style">
        <div className="container">
          <div
            className="section-title"
            data-aos="fade-down"
            data-aos-duration="800"
          >
            <div className="text-uppercase">Features</div>
            <h4 className="text-uppercase">Features we offer you</h4>
          </div>
          {/* ---------Blockchain-------- */}

          <div
            className="row"
            data-aos="fade-up-right"
            data-aos-delay="200"
            data-aos-duration="1000"
          >
            <div className="image-wrapper col-lg-4 col-md-5 col-sm-12 d-none d-sm-none d-md-block d-lg-block">
              <img src={blockchain} loading="lazy" alt="img not found" />
            </div>
            <div className="floating-card card-1 col-lg-8 col-md-7 col-sm-12">
              <div className="d-flex gap-3 align-items-center">
                <div className="card-icon">
                  <CurrencyBitcoinIcon />
                </div>
                <div>
                  <span className="card-value">Blockchain Development</span>
                </div>
              </div>
              <p>
                We create, deploy, and manage decentralized applications for
                your company's requirements.
              </p>
            </div>
          </div>  

          {/* ---------Full-Stack-Development---------- */}
          <div
            className="row"
            data-aos="fade-up-left"
            data-aos-delay="400"
            data-aos-duration="1200"
          >
            <div className="floating-card card-2 col-lg-8 col-md-7 col-sm-12">
              <div className="d-flex gap-3 align-items-center">
                <div className="card-icon">
                  <DeveloperModeIcon />
                </div>
                <div>
                  <span className="card-value">Fullstack Web Development</span>
                </div>
              </div>
              <p>
                Our extensive portfolio of website development services can be
                tailored to your company's needs.
              </p>
            </div>

            <div className="image-wrapper col-lg-4 col-md-5 col-sm-12 d-none d-sm-none d-md-block d-lg-block">
              <img src={fullstack} loading="lazy" alt="img not found" />
            </div>
          </div>
          {/* ---------App-------- */}
          <div
            className="row"
            data-aos="fade-up-right"
            data-aos-delay="600"
            data-aos-duration="1400"
          >
            <div className="image-wrapper col-lg-4 col-md-5 col-sm-12 d-none d-sm-none d-md-block d-lg-block">
              <img src={app} loading="lazy" alt="img not found" />
            </div>
            <div className="floating-card card-1 col-lg-8 col-md-7 col-sm-12">
              <div className="d-flex gap-3 align-items-center">
                <div className="card-icon">
                  <AppShortcutIcon />
                </div>
                <div>
                  <span className="card-value">Android & IOS Applications</span>
                </div>
              </div>
              <p>
                We guarantee that your app will work on all devices, giving your
                customers access to the same fantastic experience.
              </p>
            </div>
          </div>

          {/* ---------Crypto Payment---------- */}
          <div
            className="row"
            data-aos="fade-up-left"
            data-aos-delay="800"
            data-aos-duration="1600"
          >
            <div className="floating-card card-2 col-lg-8 col-md-7 col-sm-12">
              <div className="d-flex gap-3 align-items-center">
                <div className="card-icon">
                  <PaymentIcon />
                </div>
                <div>
                  <span className="card-value">Crypto Payment Gateway</span>
                </div>
              </div>
              <p>
                With the help of our quick and secure payment processing
                service, you can quickly incorporate cryptocurrency.
              </p>
            </div>
            <div className="image-wrapper col-lg-4 col-md-5 col-sm-12 d-none d-sm-none d-md-block d-lg-block">
              <img src={payment} loading="lazy" alt="img not found" />
            </div>
          </div>

          {/* ---------Exchange-------- */}
          <div
            className="row"
            data-aos="fade-up-right"
            data-aos-delay="1000"
            data-aos-duration="1800"
          >
            <div className="image-wrapper col-lg-4 col-md-5 col-sm-12 d-none d-sm-none d-md-block d-lg-block">
              <img src={exchange} loading="lazy" alt="img not found" />
            </div>
            <div className="floating-card card-1 col-lg-8 col-md-7 col-sm-12">
              <div className="d-flex gap-3 align-items-center">
                <div className="card-icon">
                  <CurrencyExchangeIcon />
                </div>
                <div>
                  <span className="card-value">Crypto Creation & Exchange</span>
                </div>
              </div>
              <p>
                We are here to create crypto for your company, and we have an
                exchange where you may trade in your crypto.
              </p>
            </div>
          </div>
        </div>
      </section>
    </Fragment>
  );
};
export default Features;
